import { notify } from '@tiger/bugsnag';
import { type FC, useEffect, useRef } from 'react';
import { Navigate, type NavigateProps, useLocation } from 'react-router-dom';

interface InvalidRedirectProps extends NavigateProps {
    /** 上报原因 */
    errorMsg: string;
    /** 上报携带的额外字段 */
    data?: Record<string, any>;
}

/**
 * 非法访问页面重定向，默认 replace 到指定的新路由，并上报重定向原因方便排查问题
 * 若不需要 replace ，需要手动设置 replace={false}
 */
const InvalidRedirect: FC<InvalidRedirectProps> = ({ errorMsg, data, replace = true, ...props }) => {
    const location = useLocation();

    const error = new Error(`[InvalidRedirect]: ${errorMsg}`);
    const reportData = {
        before: location.pathname,
        after: props.to,
        ...(data ?? {})
    };

    const self = useRef({ data: reportData, error }).current;

    self.data = reportData;
    self.error = error;

    useEffect(() => {
        notify(self.error, self.data);
    }, [self]);

    return <Navigate replace={replace} {...props} />;
};

export default InvalidRedirect;
